import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { HashLink } from 'react-router-hash-link';
import VehicleSelectorModal from '../../VehicleSelectorModal';
import {
    findPerformanceCategoryId,
    getRacingCheckboxLabel,
    isRacingCategoryName,
} from '../../../utils/racingCategory';
import {
    clearBrowseName,
    findNameById,
    getItemListNameFromCategory,
    nameFromSelect,
    persistBrowseName,
    trackSearchPerformed,
    trackSelectItem,
    trackViewIn3dClicked,
    trackViewItemList,
} from '../../../utils/dataLayer';

export default class SearchForm extends React.Component {

    state = {
        accessories: [],
        categories: [],
        models: [],
        years: [],
        selectedModelName: '',
        selectedModelImage: '',
        current_page: 1,
        next_page: false,
        isAccessoriesLoading: false,
        formModel: '',
        formYear: 'all',
        formCategory: 'all',
        isNewCategoryDisabled: false,
        show3dModal: false,
        accessoryIdFor3d: null,
        show3dOnly: false,
        has_3d_accessories: false,
        showRacingOnly: false,
        has_racing_accessories: false,
        racingCategoryId: null,
    }

componentDidMount() {
        this._isMounted = true;
        const selectedModel = localStorage.getItem('selectedModel') || 'all';
        const selectedYear = localStorage.getItem('selectedYear') || 'all';
        let selectedCategory = this.props.initialCategoryId || localStorage.getItem('selectedCategory') || 'all';
        // Deeplink wins; otherwise restore like model/year/category so PDP remount keeps the filter.
        const show3dOnly =
            process.env.REACT_APP_BRAND_ID === '1' &&
            (
                this.props.initialShow3dOnly === true ||
                localStorage.getItem('show3dOnly') === '1'
            );
        const language = localStorage.getItem('language') || 'en';
        const selectedCategoryName = localStorage.getItem('selectedCategoryName') || '';
        // Explicit non-racing category (e.g. home/nav cards) wins over a sticky
        // showRacingOnly flag left over from a previous visit.
        const hasExplicitNonRacingCategory =
            selectedCategory &&
            selectedCategory !== 'all' &&
            !isRacingCategoryName(selectedCategoryName);

        // Racing is filtered via the checkbox, not the category dropdown. If LS still
        // holds the racing category id (or name), treat it as showRacingOnly so the
        // select is not stuck on a hidden option with no way to clear the filter.
        let racingOnlyFromStorage =
            process.env.REACT_APP_BRAND_ID === '1' &&
            !hasExplicitNonRacingCategory &&
            (
                localStorage.getItem('showRacingOnly') === '1' ||
                isRacingCategoryName(selectedCategoryName)
            );

        if (this.props.initialCategoryId) localStorage.setItem('selectedCategory', this.props.initialCategoryId);

        if (hasExplicitNonRacingCategory) {
            localStorage.removeItem('showRacingOnly');
            racingOnlyFromStorage = false;
        } else if (racingOnlyFromStorage) {
            selectedCategory = 'all';
            localStorage.setItem('selectedCategory', 'all');
            localStorage.setItem(
                'selectedCategoryName',
                language === 'en' ? 'All Categories' : 'كل الفئات'
            );
            localStorage.setItem('showRacingOnly', '1');
        }

        if (show3dOnly) {
            localStorage.setItem('show3dOnly', '1');
        }

        this.setState({
            formModel: selectedModel,
            formYear: selectedYear,
            formCategory: selectedCategory,
            show3dOnly,
            showRacingOnly: racingOnlyFromStorage,
        }, () => {
            this.fetchInitialData();
        });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

fetchInitialData = () => {
        const { formModel, formYear, formCategory, show3dOnly, showRacingOnly, racingCategoryId } = this.state;

        if (formModel && formModel !== 'all') {
            this.fetchYears(formModel);
            this.fetchModelDetails(formModel);
        } else {
            this.setState({ years: [] });
        }

        let filter = '';
        if(formModel && formModel !== 'all') filter += '&model_id=' + formModel;
        if(formYear && formYear !== 'all') filter += '&year_id=' + formYear;
        if (process.env.REACT_APP_BRAND_ID === '1' && showRacingOnly && racingCategoryId) {
            filter += '&category_id=' + racingCategoryId;
        } else {
            if(formCategory && (formCategory !== 'all' && formCategory !== 'new')) filter += '&category_id=' + formCategory;
            if(formCategory && formCategory === 'new') filter += '&per_page=9&order_by=created_at&order_by_dir=desc&limit=9';
        }
        if(process.env.REACT_APP_BRAND_ID === '1' && show3dOnly) filter += '&show_3d_only=1';

        this.fetchAccessories(filter);
        this.fetchModels();
        this.fetchCategories();
    }

trackListAnalytics = (res, { trackSearch = false, page = 1 } = {}) => {
    const { formModel, formYear, formCategory, show3dOnly, showRacingOnly, racingCategoryId } = this.state;
    const accessories = res?.data || [];
    const resultCount = res?.total != null ? res.total : accessories.length;
    const itemListName = getItemListNameFromCategory(formCategory);
    const racingName = (showRacingOnly && racingCategoryId)
        ? findNameById(this.state.categories, racingCategoryId)
        : '';
    const browseOverrides = (showRacingOnly && racingCategoryId)
        ? { category_id: racingCategoryId, category_name: racingName }
        : {};
    if (trackSearch) {
        trackSearchPerformed({
            resultCount,
            show3dOnly,
            showRacingOnly,
            racingCategoryId,
            formCategory,
            formModel,
            formYear,
            modelName: findNameById(this.state.models, formModel),
            yearName: findNameById(this.state.years, formYear, ['year', 'name']),
            categoryName: racingName || findNameById(this.state.categories, formCategory),
        });
    }
    trackViewItemList({
        accessories,
        itemListName,
        page,
        browseOverrides,
        force: trackSearch,
        show3dOnly,
        showRacingOnly,
    });
}

fetchYears = (modelId) => {
    const dealer_id = localStorage.getItem('dealer_id');
    let token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
    const config = {
        headers: { 'Authorization': token, 'X-Locale': localStorage.getItem('language') || 'en'}
    };

    axios.get(
        `${process.env.REACT_APP_FORD_API_URL}/api/v1/car-models/${modelId}?dealer_id=${dealer_id}&brand_id=${process.env.REACT_APP_BRAND_ID}&market_id=${process.env.REACT_APP_MARKET_ID}`,
        config
    ).then(res => {
        if (!this._isMounted) return;
        const years = [...(res.data.years || [])].sort(
            (a, b) => (parseInt(b.year || b.name, 10) || 0) - (parseInt(a.year || a.name, 10) || 0)
        );
        this.setState({ years }, () => {
            const yearId = this.state.formYear;
            if (yearId && yearId !== 'all') {
                persistBrowseName('selectedYearName', findNameById(years, yearId, ['year', 'name']));
            }
        });
    });
}

fetchModelDetails = (modelId) => {
    let language = localStorage.getItem('language') || 'en';
    if (modelId === 'all') {
        this.setState({ 
            selectedModelName: 'All Models',
            selectedModelImage: ''
        });
        return;
    }

    const dealer_id = localStorage.getItem('dealer_id');
    let token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
    const config = {
        headers: { 'Authorization': token, 'X-Locale': localStorage.getItem('language') || 'en'}
    };

    axios.get(
        `${process.env.REACT_APP_FORD_API_URL}/api/v1/car-models/${modelId}?dealer_id=${dealer_id}&brand_id=${process.env.REACT_APP_BRAND_ID}&market_id=${process.env.REACT_APP_MARKET_ID}`,
        config
    ).then(res => {
        if (!this._isMounted) return;
        persistBrowseName('selectedModelName', res.data.name);
        this.setState({
            selectedModelName: res.data.name,
            selectedModelImage: res.data.media[0].original_url
        });
    });
}

fetchAccessories = (filter, { trackSearch = false } = {}) => {
    const dealer_id = localStorage.getItem('dealer_id');
    const country_id = localStorage.getItem('country_id') || '';
    const countryParam = country_id ? `&country_id=${country_id}` : '';
    let token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
    const config = {
        headers: { 'Authorization': token, 'X-Locale': localStorage.getItem('language') || 'en'}
    };

    this._accessoriesReqId = (this._accessoriesReqId || 0) + 1;
    const reqId = this._accessoriesReqId;
    this.setState({ isAccessoriesLoading: true });
    axios.get(
        `${process.env.REACT_APP_FORD_API_URL}/api/v1/accessories/filter?dealer_id=${dealer_id}&per_page=12${filter}${countryParam}&brand_id=${process.env.REACT_APP_BRAND_ID}&market_id=${process.env.REACT_APP_MARKET_ID}`,
        config
    ).then(res => {
        if (!this._isMounted || reqId !== this._accessoriesReqId) return;
        const hasRacing = !!res.data.has_racing_accessories;
        this.setState((prev) => {
            // Don't clear a sticky racing filter until racingCategoryId is known and
            // applied — remount fetches before categories resolve and would wipe LS restore.
            let showRacingOnly = prev.showRacingOnly;
            if (!hasRacing && prev.showRacingOnly && prev.racingCategoryId) {
                showRacingOnly = false;
                localStorage.removeItem('showRacingOnly');
            }
            return {
                accessories: res.data.data,
                next_page: !!res.data.next_page_url,
                has_3d_accessories: !!res.data.has_3d_accessories,
                has_racing_accessories: hasRacing,
                showRacingOnly,
                isAccessoriesLoading: false,
            };
        });
        this.trackListAnalytics(res.data, { trackSearch, page: 1 });
    }).catch((err) => {
        console.error('Error fetching accessories:', err);
        if (!this._isMounted || reqId !== this._accessoriesReqId) return;
        this.setState({ isAccessoriesLoading: false });
        if (trackSearch) {
            this.trackListAnalytics({ data: [], total: 0 }, { trackSearch: true, page: 1 });
        }
    });
}

fetchModels = () => {
    const dealer_id = localStorage.getItem('dealer_id');
    let token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
    const config = {
        headers: { 'Authorization': token, 'X-Locale': localStorage.getItem('language') || 'en'}
    };

    axios.get(
        `${process.env.REACT_APP_FORD_API_URL}/api/v1/car-models/filter?brand_id=${process.env.REACT_APP_BRAND_ID}&dealer_id=${dealer_id}&market_id=${process.env.REACT_APP_MARKET_ID}`,
        config
    ).then(res => {
        if (!this._isMounted) return;
        const language = localStorage.getItem('language') || 'en';
        const models = [...(res.data.data || [])].sort((a, b) =>
            String(a?.name || '').localeCompare(String(b?.name || ''), language, { sensitivity: 'base' })
        );
        this.setState({ models }, () => {
            const modelId = this.state.formModel;
            if (modelId && modelId !== 'all') {
                persistBrowseName('selectedModelName', findNameById(models, modelId));
            }
        });
    });
}

fetchCategories = () => {
    const dealer_id = localStorage.getItem('dealer_id');
    let token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
    const config = {
        headers: { 'Authorization': token, 'X-Locale': localStorage.getItem('language') || 'en'}
    };

    let url = `${process.env.REACT_APP_FORD_API_URL}/api/v1/categories?dealer_id=${dealer_id}&brand_id=${process.env.REACT_APP_BRAND_ID}&market_id=${process.env.REACT_APP_MARKET_ID}`;
    if (this.state.formModel && this.state.formModel !== 'all') {
        url += '&model_id=' + encodeURIComponent(this.state.formModel);
        if (this.state.formYear && this.state.formYear !== 'all') {
            url += '&year_id=' + encodeURIComponent(this.state.formYear);
        }
    }

    axios.get(url, config).then(res => {
        if (!this._isMounted) return;
        const categories = res.data || [];
        const language = localStorage.getItem('language') || 'en';
        const racingCategoryId = findPerformanceCategoryId(categories);

        categories.sort((a, b) =>
            String(a?.name || '').localeCompare(String(b?.name || ''), language, { sensitivity: 'base' })
        );

        const isFordBrand = process.env.REACT_APP_BRAND_ID === '1';
        const storedCategory = localStorage.getItem('selectedCategory');
        const isStuckOnRacingCategory =
            isFordBrand &&
            racingCategoryId &&
            (
                String(this.state.formCategory) === String(racingCategoryId) ||
                String(storedCategory || '') === String(racingCategoryId)
            );

        const showRacingOnly =
            isFordBrand && racingCategoryId
                ? (isStuckOnRacingCategory || this.state.showRacingOnly)
                : false;

        if (!showRacingOnly && this.state.showRacingOnly) {
            localStorage.removeItem('showRacingOnly');
        }

        // Migrate hidden racing category selection onto the checkbox path.
        if (isStuckOnRacingCategory) {
            const language = localStorage.getItem('language') || 'en';
            localStorage.setItem('selectedCategory', 'all');
            localStorage.setItem(
                'selectedCategoryName',
                language === 'en' ? 'All Categories' : 'كل الفئات'
            );
            localStorage.setItem('showRacingOnly', '1');
            this.setState(
                {
                    categories,
                    racingCategoryId,
                    formCategory: 'all',
                    showRacingOnly: true,
                },
                this.submitForm
            );
            return;
        }

        // Remount often restores showRacingOnly from LS before racingCategoryId exists.
        // Re-fetch once the id is known so results match the checkbox.
        const shouldResubmitRacing =
            showRacingOnly &&
            !!racingCategoryId &&
            !this.state.racingCategoryId;

        this.setState({
            categories,
            racingCategoryId,
            showRacingOnly,
        }, () => {
            if (shouldResubmitRacing) {
                this.submitForm();
            }
        });
        const catId = this.state.formCategory;
        if (catId && catId !== 'all' && catId !== 'new') {
            persistBrowseName('selectedCategoryName', findNameById(categories, catId));
        }
    });
}

handleModelChange = (event) => {
    const selectedModel = event.target.value;
    localStorage.setItem('selectedModel', selectedModel);
    if (!selectedModel || selectedModel === 'all') {
        clearBrowseName('selectedModelName');
    } else {
        persistBrowseName('selectedModelName', nameFromSelect(event));
    }
    this.setState({ 
        formModel: selectedModel, 
        formYear: 'all',  // Reset year to 'all' when model changes
//        formCategory: 'all',  // Reset category to 'all' when model changes
        years: [],
        isNewCategoryDisabled: selectedModel !== 'all',
        show3dOnly: false,  // Reset 3D-only filter when model changes so checkbox hides for models without 3D accessories
        showRacingOnly: false,
    }, () => {
        if (selectedModel && selectedModel !== 'all') {
            this.fetchYears(selectedModel);
        }
        this.submitForm();
    });
    
    if(selectedModel != 'all'){
        console.log(selectedModel);
        let selectedCategory = localStorage.getItem('selectedCategory');
        console.log(selectedCategory);
        if(selectedCategory == 'new'){
            localStorage.setItem('selectedCategory', 'all');
            localStorage.setItem('selectedCategoryName', 'All Categories');
            this.setState({ formCategory: 'all' }, this.submitForm);
        }
    }

    // Clear year and sticky checkbox filters when model changes
    localStorage.removeItem('selectedYear');
    clearBrowseName('selectedYearName');
    localStorage.removeItem('showRacingOnly');
    localStorage.removeItem('show3dOnly');
//    localStorage.removeItem('category_id');
};

handleYearChange = (event) => {
    const selectedYear = event.target.value;
    localStorage.setItem('selectedYear', selectedYear);
    if (!selectedYear || selectedYear === 'all') {
        clearBrowseName('selectedYearName');
    } else {
        persistBrowseName('selectedYearName', nameFromSelect(event) || findNameById(this.state.years, selectedYear, ['year', 'name']));
    }
    localStorage.removeItem('showRacingOnly');
    localStorage.removeItem('show3dOnly');
    this.setState({ formYear: selectedYear, show3dOnly: false, showRacingOnly: false }, this.submitForm);
};

handleCategoryChange = (event) => {
    const selectedCategory = event.target.value;
    let selectedCategoryName = 'All Categories';
    const { racingCategoryId } = this.state;

    if (selectedCategory !== 'all') {
        const selectedOption = event.target.options[event.target.selectedIndex];
        selectedCategoryName = selectedOption.textContent;
    }

    // Store category ID and name in localStorage
    localStorage.setItem('selectedCategory', selectedCategory);
    localStorage.setItem('selectedCategoryName', selectedCategoryName);
    localStorage.removeItem('showRacingOnly');
    localStorage.removeItem('show3dOnly');

    const isRacingCategory =
        racingCategoryId &&
        String(selectedCategory) === String(racingCategoryId);

    this.setState(
        {
            formCategory: selectedCategory,
            show3dOnly: false,
            showRacingOnly:
                process.env.REACT_APP_BRAND_ID === '1' && !!isRacingCategory,
        },
        this.submitForm
    );
};

handleShow3dOnlyChange = (event) => {
    const checked = event.target.checked;
    if (checked) {
        localStorage.setItem('show3dOnly', '1');
    } else {
        localStorage.removeItem('show3dOnly');
    }
    this.setState({ show3dOnly: checked }, this.submitForm);
};

handleShowRacingOnlyChange = (event) => {
    if (process.env.REACT_APP_BRAND_ID !== '1') {
        return;
    }
    const checked = event.target.checked;
    const { racingCategoryId } = this.state;
    const language = localStorage.getItem('language') || 'en';

    if (!racingCategoryId) {
        this.setState({ showRacingOnly: false }, this.submitForm);
        return;
    }

    if (checked) {
        localStorage.setItem('selectedCategory', 'all');
        localStorage.setItem(
            'selectedCategoryName',
            language === 'en' ? 'All Categories' : 'كل الفئات'
        );
        localStorage.setItem('showRacingOnly', '1');

        this.setState(
            {
                showRacingOnly: true,
                formCategory: 'all',
                accessories: [],
                next_page: false,
                current_page: 1,
            },
            this.submitForm
        );
    } else {
        localStorage.setItem('selectedCategory', 'all');
        localStorage.setItem(
            'selectedCategoryName',
            language === 'en' ? 'All Categories' : 'كل الفئات'
        );
        localStorage.removeItem('showRacingOnly');

        this.setState(
            {
                showRacingOnly: false,
                formCategory: 'all',
                accessories: [],
                next_page: false,
                current_page: 1,
            },
            this.submitForm
        );
    }
};

submitForm = () => {
    const { formModel, formYear, formCategory, show3dOnly, showRacingOnly, racingCategoryId } = this.state;
    let filter = '';
    if(formModel && formModel !== 'all') filter += '&model_id=' + formModel;
    if(formYear && formYear !== 'all') filter += '&year_id=' + formYear;
    if (process.env.REACT_APP_BRAND_ID === '1' && showRacingOnly && racingCategoryId) {
        filter += '&category_id=' + racingCategoryId;
    } else {
        if(formCategory && (formCategory !== 'all' && formCategory !== 'new')) filter += '&category_id=' + formCategory;
        if(formCategory && formCategory === 'new') filter += '&per_page=9&order_by=created_at&order_by_dir=desc&limit=9';
    }
    if(process.env.REACT_APP_BRAND_ID === '1' && show3dOnly) filter += '&show_3d_only=1';

    this.setState({ current_page: 1 });
    this.fetchAccessories(filter, { trackSearch: true });
    this.fetchModelDetails(formModel);
    this.fetchCategories(); // Refetch so category list is model-aware (e.g. Performance only for Bronco)
};

handlePreviousClick = (event) => {
    let current_page = this.state.current_page - 1;
    this.setState({ current_page });
    this.fetchPagedAccessories(current_page);
}

handleNextClick = (event) => {
    let current_page = this.state.current_page + 1;
    this.setState({ current_page });
    this.fetchPagedAccessories(current_page);
}

fetchPagedAccessories = (page) => {
    const { formModel, formYear, formCategory, show3dOnly, showRacingOnly, racingCategoryId } = this.state;
    const dealer_id = localStorage.getItem('dealer_id');
    const country_id = localStorage.getItem('country_id') || '';
    const countryParam = country_id ? `&country_id=${country_id}` : '';
    let token = 'Bearer ' + process.env.REACT_APP_FORD_API_TOKEN;
    const config = {
        headers: { 'Authorization': token, 'X-Locale': localStorage.getItem('language') || 'en'}
    };

    let filter = '';
    if(formModel && formModel !== 'all') filter += '&model_id=' + formModel;
    if(formYear && formYear !== 'all') filter += '&year_id=' + formYear;
    if (process.env.REACT_APP_BRAND_ID === '1' && showRacingOnly && racingCategoryId) {
        filter += '&category_id=' + racingCategoryId;
    } else {
        if(formCategory && (formCategory !== 'all' && formCategory !== 'new')) filter += '&category_id=' + formCategory;
        if(formCategory && formCategory === 'new') filter += '&per_page=9&order_by=created_at&order_by_dir=desc&limit=9';
    }
    if(process.env.REACT_APP_BRAND_ID === '1' && show3dOnly) filter += '&show_3d_only=1';
    filter += '&page=' + page;

    axios.get(
        `${process.env.REACT_APP_FORD_API_URL}/api/v1/accessories/filter?dealer_id=${dealer_id}&per_page=12${filter}${countryParam}&brand_id=${process.env.REACT_APP_BRAND_ID}&market_id=${process.env.REACT_APP_MARKET_ID}`,
        config
    ).then(res => {
        if (!this._isMounted) return;
        const hasRacing = !!res.data.has_racing_accessories;
        this.setState((prev) => {
            let showRacingOnly = prev.showRacingOnly;
            if (!hasRacing && prev.showRacingOnly && prev.racingCategoryId) {
                showRacingOnly = false;
                localStorage.removeItem('showRacingOnly');
            }
            return {
                accessories: res.data.data,
                next_page: !!res.data.next_page_url,
                has_3d_accessories: !!res.data.has_3d_accessories,
                has_racing_accessories: hasRacing,
                showRacingOnly,
            };
        });
        this.trackListAnalytics(res.data, { trackSearch: false, page });
    });
}

slugify(text) {
    return text.toString().toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\p{L}\p{N}\-]+/gu, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
}

renderHeading = () => {
        const selectedCategory = localStorage.getItem('selectedCategory');
        const selectedCategoryName = localStorage.getItem('selectedCategoryName');
        const { selectedModelName, selectedModelImage } = this.state;

        if ((!this.state.formModel || this.state.formModel === 'all') && selectedCategory && selectedCategory !== 'all') {
            return <span>{selectedCategoryName}</span>;
        }

        return (
            <>
                <span language="ar">ملحقات من أجل</span>
                <span language="en">Accessories for </span>
                {' '}
                {selectedModelName}
                {selectedModelName !== 'All Models' && selectedModelImage && (
                    <img
                        className="m-2"
                        style={{ width: '100px', height: 'auto' }}
                        src={selectedModelImage}
                        alt={selectedModelName}
                    />
                )}
            </>
        );
    }

render() {
        const { accessories, categories, models, years, current_page, next_page, isAccessoriesLoading, selectedModelName, selectedModelImage, formModel, formYear, formCategory, isNewCategoryDisabled, show3dOnly, has_3d_accessories, showRacingOnly, has_racing_accessories, racingCategoryId } = this.state;
    let hasHeroImage = false;
    let language = localStorage.getItem('language') || 'en';
    // Keep checkboxes visible while sticky filters are on (same as racing), so PDP
    // remount does not hide them before the API flags return.
    const show3dCheckbox =
        process.env.REACT_APP_BRAND_ID === '1' &&
        (has_3d_accessories || show3dOnly);
    const showRacingCheckbox =
        process.env.REACT_APP_BRAND_ID === '1' &&
        (has_racing_accessories || showRacingOnly);

    return (
        <div className="container">
            <div className="d-block">
                <div className="filter-form">
                    <form onSubmit={(event) => event.preventDefault()}>
                        <div className="row">
                            <div className="col-12 col-md-4 col-lg-3 col-xl-3">
                                <select className="form-select" aria-label="" onChange={this.handleModelChange} value={formModel}>
                                    <option value='all'>
                                        {language === 'en' ? 'All Models' : 'كل الموديلات'}
                                    </option>
                                    {models.map((model, key) => (
                                        <option key={key} value={model.id}>{model.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-12 col-md-4 col-lg-3 col-xl-3">
                                <select className="form-select" aria-label="" onChange={this.handleYearChange} value={formYear} disabled={!formModel || formModel === 'all'}>
                                    <option value='all'>
                                        {language === 'en' ? 'All Years' : 'كل السنوات'}
                                    </option>
                                    {years.map((year, key) => (
                                        <option key={key} value={year.id}>{year.year}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-12 col-md-4 col-lg-3 col-xl-3">
                                <select 
                                    className="form-select" 
                                    aria-label="" 
                                    onChange={this.handleCategoryChange} 
                                    value={this.state.formCategory}
                                >
                                    <option value='all'>
                                        {language === 'en' ? 'All Categories' : 'كل الفئات'}
                                    </option>
                                    {categories
                                        .filter((category) => !racingCategoryId || String(category.id) !== String(racingCategoryId))
                                        .map((category, key) => (
                                            <option key={key} value={category.id}>{category.name}</option>
                                        ))}
                                    <option value='new' disabled={isNewCategoryDisabled}>
                                        {language === 'en' ? 'New Accessories' : 'ملحقات جديدة'}
                                    </option>
                                </select>
                            </div>
                        </div>                
                    </form>
                </div>
            </div>

            <div className="accessories">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2">
                    <h2 className="mb-0">{this.renderHeading()}</h2>
                    <div className="d-flex align-items-center gap-3">
                        {show3dCheckbox && (
                            <label className="d-flex align-items-center gap-2 mb-0 accessory-show-3d-only" style={{ cursor: 'pointer', fontWeight: 'normal' }}>
                                <input type="checkbox" checked={show3dOnly} onChange={this.handleShow3dOnlyChange} className="form-check-input" />
                                <span>{language === 'en' ? 'Show 3D Only' : 'منظر ثلاثي الأبعاد 3D فقط'}</span>
                            </label>
                        )}
                        {showRacingCheckbox && (
                            <label className="d-flex align-items-center gap-2 mb-0 accessory-show-3d-only" style={{ cursor: 'pointer', fontWeight: 'normal' }}>
                                <input type="checkbox" checked={showRacingOnly} onChange={this.handleShowRacingOnlyChange} className="form-check-input" />
                                <span>{getRacingCheckboxLabel(language)}</span>
                            </label>
                        )}
                    </div>
                </div>
                <div className="row gx-5">
                    {isAccessoriesLoading && (
                        <div className="loader-container">
                            <div className="loader">
                                <img src="/images/Rolling@1x-1.0s-200px-200px.gif" width={100} height={100} alt="Loading" />
                            </div>
                        </div>
                    )}
                    {process.env.REACT_APP_BRAND_ID === '1' && show3dOnly && (!accessories || accessories.length === 0) ? (
                        <div className="col-12 py-5 text-center accessories-empty-3d">
                            <p className="mb-0 text-muted" style={{ fontSize: '1.125rem' }}>
                                {language === 'en' ? 'No accessories found.' : 'لم يتم العثور على ملحقات.'}
                            </p>
                        </div>
                    ) : accessories && accessories.map((accessory, key) => {
                        const isRacingAccessory = !!(
                            (racingCategoryId && Array.isArray(accessory.category_ids) && accessory.category_ids.some((id) => String(id) === String(racingCategoryId))) ||
                            (racingCategoryId && String(accessory.category_id || '') === String(racingCategoryId)) ||
                            accessory.is_racing
                        );
                        // Only badge true racing parts — never every card just because the filter is on.
                        const showRacingIcon =
                            process.env.REACT_APP_BRAND_ID === '1' && isRacingAccessory;
                        return (
                        <div className="col-12 col-md-6 col-lg-3" key={key}>
                            <div className="accessory">
                                <Link
                                    to={"/accessory/" +accessory.id+"/"+this.slugify(accessory.accessory_name)}
                                    onClick={() => trackSelectItem(accessory, getItemListNameFromCategory(formCategory))}
                                >
                                    <div style={{ position: 'relative' }}>
                                    {accessory.media && accessory.media.map((media, index) => {
                                        if (media.collection_name === "print-image") {
                                            hasHeroImage = true;
                                                return <img key={index} src={media.original_url} alt={accessory.accessory_name}/>;
                                        }
                                        return null;
                                    })}
                                    { !hasHeroImage && <img src="../images/default.jpg" alt={accessory.accessory_name}/>}
                                    {hasHeroImage = false}
                                        {process.env.REACT_APP_BRAND_ID === '1' && accessory.has_3d && (
                                            <span
                                                className="badge-3d"
                                                title="3D View Available"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    trackViewIn3dClicked(accessory.id, 'search_list');
                                                    this.setState({ accessoryIdFor3d: accessory.id, show3dModal: true });
                                                }}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <img src="/images/3d-icon-white-128x.png" alt="3D" />
                                            </span>
                                        )}
                                    </div>
                                </Link>
                                {showRacingIcon && (
                                    <img className="racing-logo-inline" src="/images/racing-horizontal.png" alt="Ford Racing" height="17.42px" width="auto"/>
                                )}
                                <p className="name">
                                    <Link
                                        to={"/accessory/" +accessory.id+"/"+this.slugify(accessory.accessory_name)}
                                        onClick={() => trackSelectItem(accessory, getItemListNameFromCategory(formCategory))}
                                    >{accessory.accessory_name}</Link>
                                </p>
                            </div>
                        </div>
                    )})}
                </div>
            </div>

            {process.env.REACT_APP_BRAND_ID === '1' && this.state.show3dModal && this.state.accessoryIdFor3d && (
                <VehicleSelectorModal
                    accessoryId={this.state.accessoryIdFor3d}
                    onClose={() => this.setState({ show3dModal: false, accessoryIdFor3d: null })}
                />
            )}

            { formCategory !== 'new' &&
            <div className="pagination">
                <div className="links">
                    { current_page > 1 && 
                        <span className="prev">
                            <HashLink to="#" onClick={this.handlePreviousClick}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-double-left" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                                    <path fillRule="evenodd" d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                                </svg>
                                <span language="ar">سابق</span>
                                <span language="en">Previous</span>
                            </HashLink>    
                        </span>
                    }
                    <span className="current">
                        {current_page}
                    </span>
                    { next_page && 
                        <span className="next">
                            <HashLink to="#" onClick={this.handleNextClick}>
                                <span language="ar">التالي</span>
                                <span language="en">Next</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708"/>
                                    <path fillRule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708"/>
                                </svg>
                            </HashLink>
                        </span>
                    }
                </div>
            </div>
                }

        </div>
    )
}
}